import React, {memo} from "react";
import PropTypes from "prop-types";
import {Modal, ModalHeader} from "reactstrap";
import Loader from "../../../components/Loader";
import AddCustomerForm from "./form";

const AddCustomer = (props) => {
  const {data, defaultRoute, onCancel, open} = props;

  return (
    <Modal unmountOnClose={true} isOpen={open} backdrop={"static"} size={"lg"}>
      <Loader />
      <ModalHeader>{data && data.id ? "Edit Customer" : "Add Customer"}</ModalHeader>
      <AddCustomerForm data={data} defaultRoute={defaultRoute} onCancel={onCancel} />
    </Modal>
  );
};

AddCustomer.propTypes = {
  data: PropTypes.object,
  defaultRoute: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

export default memo(AddCustomer);
